document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.js-mega-menu-item');
  const CLOSE_DELAY = 400;

  if (!menuItems.length) return;

  function getElements(item) {
    return {
      trigger: item.querySelector('.header__menu-item'),
      panel: item.querySelector('.mega-menu__content'),
    };
  }

  function isOpen(item) {
    const { panel } = getElements(item);
    return panel && !panel.hasAttribute('hidden');
  }

  function openMenu(item) {
    const { trigger, panel } = getElements(item);

    if (!trigger || !panel) return;

    closeAllMenus(item);

    item.setAttribute('open', '')
    panel.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu(item) {
    const { trigger, panel } = getElements(item);

    if (!trigger || !panel) return;

    item.removeAttribute('open', '')
    panel.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllMenus(exceptItem = null) {
    menuItems.forEach((item) => {
      if (item !== exceptItem) {
        closeMenu(item);
      }
    });
  }

  menuItems.forEach((item) => {
    const { trigger, panel } = getElements(item);

    if (!trigger || !panel) return;

    let closeTimer;

    function clearCloseTimer() {
      clearTimeout(closeTimer);
    }

    function scheduleClose() {
      clearCloseTimer();

      closeTimer = setTimeout(() => {
        const containsFocusedElement = item.contains(document.activeElement);
        const isHovered = item.matches(':hover');

        if (!containsFocusedElement && !isHovered) {
          closeMenu(item);
        }
      }, CLOSE_DELAY);
    }

    function keepOpen() {
      clearCloseTimer();
      openMenu(item);
    }

    item.addEventListener('mouseenter', keepOpen);
    item.addEventListener('mouseleave', scheduleClose);

    trigger.addEventListener('focus', keepOpen);

    const focusableInsidePanel = panel.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

    focusableInsidePanel.forEach((element) => {
      element.addEventListener('focus', () => {
        clearCloseTimer();
        openMenu(item);
      });
    });

    item.addEventListener('focusout', (event) => {
      const nextFocusedElement = event.relatedTarget;

      if (!nextFocusedElement || !item.contains(nextFocusedElement)) {
        scheduleClose();
      }
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu(item);
        trigger.focus();
      }
    });

    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu(item);
        trigger.focus();
      }
    });
  });

  document.addEventListener('click', (event) => {
    const clickedInsideMenu = event.target.closest('.js-mega-menu-item');

    if (!clickedInsideMenu) {
      closeAllMenus();
    }
  });
});
